import crypto from 'crypto'
import { ChameleonProductsAttribute } from 'models/chameleon.model'
import { IUserModel } from 'models/user.model'
import { CHAMELEON_SECRET, CHAMELEON_KEY, isProd } from 'config'

export function hashUserToken(token: string) {
  const secret = CHAMELEON_SECRET || ''
  const now = Math.floor(Date.now() / 1000)
  return [
    crypto.createHmac('sha256', secret).update(`${token}-${now}`).digest('hex'),
    now,
  ].join('-')
}

export function makeAdminsAttributes(user) {
  if (user?.permissions) {
    const permissions = new ChameleonProductsAttribute(user?.permissions)
    return permissions.toMap()
  }
  return {}
}

export function currentUserFormatted(currentUser: IUserModel) {
  return {
    uid_hash: hashUserToken(currentUser?.token),
    token: currentUser?.token,
    email: currentUser?.email,
    name: currentUser?.name,
    last_name: currentUser?.lastname,
    full_name: `${currentUser?.name} ${currentUser?.lastname}`,
    lang: currentUser?.lang || 'es',
    is_superadmin: currentUser?.is_superadmin,
    is_admin: currentUser?.is_admin,
    final_currentUser:
      !currentUser?.is_superadmin &&
      !currentUser?.is_admin &&
      !currentUser?.permissions,
    ...makeAdminsAttributes(currentUser),
    company: {
      uid: currentUser?.enterprise.id,
      token: currentUser?.enterprise.token,
      name: currentUser?.enterprise.name,
      subdomain: currentUser?.enterprise.customDomain,
    },
  }
}

export const canActiveChmln = () => {
  return !!(isProd && CHAMELEON_KEY)
}

export const canIdenetifyChmln = (currentUser) => {
  return currentUser?.token && !currentUser?.is_superadmin
}
